module.exports = __webpack_public_path__ + "static/media/Cover image.17fa3778.png";